import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { UserType } from '../../_models';


@Injectable({
  providedIn: 'root'
})
export class UserTypeService {
  data :UserType[]
  constructor() {
    
    this.data=[
      {id:1,name:"Students"},
      {id:2,name:"Teachers"},
      {id:3,name:"Parents"},
      {id:4,name:"Supervisor"},
      {id:5,name:"Mentors"},
      {id:6,name:"Managers"},
      {id:7,name:"Admin"},
      {id:8,name:"Employees"},
      {id:9,name:"Owners"}
  ]
  }
  
  getUserType() :UserType[]{
    return this.data;
  }

  getVisableType(): any[] {
    return [
      { id: 1, name: "All Students" },
      { id: 2, name: "All Teachers" },
      { id: 3, name: "All Parent (Active)" },
      { id: 4, name: "All Parents (Alumni)" },
    ]
  }

  count ():number {
    return  this.data.length;
  }



  


}


